import { render } from "./MyLoads.vue?vue&type=template&id=7457b588&scoped=true"
import script from "./MyLoads.vue?vue&type=script&lang=js"
export * from "./MyLoads.vue?vue&type=script&lang=js"

import "./MyLoads.vue?vue&type=style&index=0&id=7457b588&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7457b588"]])

export default __exports__